import { useLotteryServer } from 'middle-domain';
import { isInIframe } from '@/app-shared/utils/tool';

export default {
  computed: {
    webinarId() {
      return this.$domainStore.state.roomBaseServer?.watchInitData?.webinar?.id;
    },
    // 是否乐乐嵌入模式
    isLeleEmbedMode() {
      return (
        this.$domainStore.state.roomBaseServer?.configList?.['lele_interact_model'] && isInIframe()
      );
    }
  },
  methods: {
    // 抽奖中奖人员导出
    handleExport(lotteryId) {
      const params = {
        id: lotteryId,
        webinar_id: this.webinarId
      };
      useLotteryServer({ mode: 'live' })
        .exportWinnersInfo(params)
        .then(res => {
          if (res?.code == 200) {
            if (isInIframe()) {
              window.top.postMessage(
                {
                  type: 'lottery_winners_export_success',
                  data: { ...params }
                },
                '*'
              );
            } else {
              this.$message({
                message: this.$t('common.common_1048'),
                type: 'success'
              });
            }
          }
        });
    }
  }
};
